import { FC } from 'react';

import { ScrollView, View } from '@rbilabs/universal-components';

import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { isWeb } from 'utils/environment';

import { IScrollContainerProps } from './types';

export const ScrollContainer: FC<IScrollContainerProps> = ({ children, width }) => {
  const isDesktop = useIsDesktopBreakpoint();
  if (isDesktop && isWeb) {
    return (
      <ScrollView
        flex={1}
        overflowX="hidden"
        nativeID="main"
        showsVerticalScrollIndicator
        contentContainerStyle={{ flexGrow: 1 }}
      >
        {children}
      </ScrollView>
    );
  }
  return (
    <View flex={1} overflowX="hidden" nativeID="main">
      {children}
    </View>
  );
};
